export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13766.ab887071.jpg";